export const ROUTE_PATHS = {
  LOGIN: '/',
  PORTAL: '/portal',
  PROJECTS: '/portal',
  PROJECT: (id: string) => `/portal/projects/${id}`,
};
